<template>
  <div class="home-block mt20 task-step-block">
    <div class="home-block-title-box">
      <p class="home-block-title">操作引导</p>
    </div>
    <div class="task-step-box">
      <div v-for="(item, index) in list" :key="index" class="task-item" :class="'task'+Number(index+1)">
        <p class="task-title">{{ item.title }}</p>
        <p class="task-desc">{{ item.desc }}</p>
        <a :href="item.link.url" target="_blank" class="task-link" :clstag="item.link.clstag">{{ item.link.text }}</a>
        <router-link v-if="item.btn" :to="{name: item.btn.pathName }" tag="div" class="task-btn" :clstag="item.btn.clstag">{{ item.btn.text }}</router-link>
        <div v-if="item.btns">
          <router-link
            v-for="btn in item.btns"
            :key="btn.text"
            :to="{name: btn.pathName }"
            class="task-btn task-btn-inline"
            :clstag="btn.clstag"
          >
            {{ btn.text }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopManage',
  components: {
  },
  filters: {
    formateBusinessType(businessType) {
      const list = {
        110: '全渠道',
        200: 'POP商家',
        300: '供应商',
      };
      if (typeof businessType !== 'undefined') {
        return list[businessType];
      }
      return '--';
    },
  },
  data() {
    return {
      list: [],
      isOpen: false, // 是否展示超出店铺数量
    };
  },
  created() {
    this.getShopList();
  },
  methods: {
    // 获取店铺列表
    getShopList() {
      this.list = [{
        title: '步骤一：绑定企业资产',
        desc: '绑定企业资产统一管理',
        link: {
          url: '//helpcenter.jd.com/vender/issue/43142.html',
          text: '绑定资产指导',
          clstag: 'pageclick|keycount|home|new_help_bind',
        },
        btns: [
          {
            pathName: 'bindShop',
            text: '店铺',
            clstag: 'pageclick|keycount|index_manage_new_01|1',
          }, {
            pathName: 'bindVc',
            text: '供应商',
            clstag: 'pageclick|keycount|index_manage_new_02|1',
          },
        ],
        icon: 'task1',
      }, {
        title: '步骤二：添加企业员工',
        desc: '邀请企业的员工加入企业中心',
        link: {
          url: '//helpcenter.jd.com/vender/issue/43142.html',
          text: '添加企业员工指导',
          clstag: 'pageclick|keycount|home|new_help_add',
        },
        btn: {
          pathName: 'staffList',
          text: '去添加',
          clstag: 'pageclick|keycount|index_manage_new_03|1',
        },
        icon: 'task2',
      }, {
        title: '步骤三：资产授权',
        desc: '将企业的资产账号授权给员工',
        link: {
          url: '//helpcenter.jd.com/vender/issue/43142.html',
          text: '账号授权指导',
          clstag: 'pageclick|keycount|home|new_help_authorize',
        },
        btn: {
          pathName: 'staffQuickBind',
          text: '去授权',
          clstag: 'pageclick|keycount|index_manage_new_04|1',
        },
        icon: 'task3',
      }, {
        title: '帮助中心',
        desc: '帮助文档&常见问题',
        link: {
          url: '//helpcenter.jd.com/vender/issue/40541-42511.html',
          text: '操作指导',
          clstag: 'pageclick|keycount|home|new_help_operate',
        },
        icon: 'task4',
      }];
    },
  },
};
</script>

<style lang="scss" scoped>
.home-index .home-block.task-step-block {
  padding: 20px 0 20px;
  .home-block-title-box {
    padding: 0 20px;
  }
}
.task-step-box {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  .task-item:last-child {
    border-right: none;
  }
  .task-item {
    flex: 1;
    padding: 0 20px;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 12px;
    border-right: 1px solid rgba(0,0,0,0.09);
    background-image: url('../../../assets/imgs/home/home-task1@3x.png');
    background-size: 60px 60px;
    background-position: 180px bottom;
    background-repeat: no-repeat;
    box-sizing: border-box;
    &.task2 {
      background-image: url('../../../assets/imgs/home/home-task2@3x.png');
    }
    &.task3 {
      background-image: url('../../../assets/imgs/home/home-task3@3x.png');
    }
    &.task4 {
      background-image: url('../../../assets/imgs/home/home-task4@3x.png');
    }
    .task-title {
      margin-bottom: 8px;
      font-size: 14px;
      color: rgba(0,0,0,1);
      font-weight: 600;
    }
    .task-link {
      display: block;
      margin-top: 16px;
      font-size: 12px;
      line-height: 12px;
      color: rgba(77,128,240,1);
      cursor: pointer;
    }
    .task-btn {
      margin-top: 29px;
      width: 67px;
      height: 30px;
      font-size: 12px;
      color: rgba(0,0,0,0.85);
      line-height: 28px;
      border: 1px solid rgba(0,0,0,0.45);
      border-radius: 18px;
      cursor: pointer;
      text-align: center;
      box-sizing: border-box;
      &:hover {
        background: rgba(240,240,240,1);
      }
      &.task-btn-inline {
        display: inline-block;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

}
</style>
